import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../app/services/loader.service';

@Component({
    selector: 'teacher',
    templateUrl: './teacher.template.html',
    styleUrls: ['./teacher.style.scss'],
    standalone: false
})
export class Teacher implements OnInit {
  constructor(
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    document.body.classList.add("module-learner");
    // Hide Loader from body
    this.loaderService.showOverlayLoader();
  }
}

